import { ColumnDef } from "@tanstack/react-table";
import React from "react";
import { Link } from "react-router-dom";
import { StatisticsAlbumItem } from "../../../api/useMusicApi";
import { TableRenderUtils } from "../../../components/Table/TableRenderUtils";
import { TFunction } from "i18next";
import { truncate } from "../../../utils";

export function statisticsAlbumsColumnsDefinition(
  t: TFunction,
): Array<ColumnDef<StatisticsAlbumItem, any>> {
  return [
    {
      id: "Image",
      header: "",
      size: 45,
      enableSorting: false,
      accessorFn: (value) => value.album_image_url,
      cell: (value) => {
        const url = value.getValue()
          ? value.getValue().replace("{}", "medium")
          : "/album_cover_default_150x150.jpg";
        return TableRenderUtils.renderBaseContent(
          <img
            height={45}
            width={45}
            className={"border rounded"}
            src={url}
            alt={"ap"}
          />,
        );
      },
    },
    {
      id: "Album",
      header: `${t("album")}`,
      size: 200,
      enableSorting: false,
      accessorFn: (value) => value.album_title,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(
          <Link
            to={`/statistics/${value.row.original.album_id}/`}
            className={"dark:text-white"}
          >
            {value.getValue()}
          </Link>,
        );
      },
    },
    {
      id: "Artist",
      header: `${t("artist")}`,
      enableSorting: false,
      accessorFn: (value) => value.artist_name,
      cell: (value) => {
        return TableRenderUtils.renderBaseContent(
          <>{truncate(value.getValue(), 80)}</>,
        );
      },
    },
  ];
}
